/**
 * CKEditor typing must not run stem-density × N keywords (or the SEO pie)
 * on the same `input` / `change:data` tick. With ~100+ keywords that freeze
 * lasts several seconds per character.
 *
 * Density counts and the SEO pie refresh this many ms after the last
 * keystroke (trailing). Keyword Enter/+/confirm may still recalc once.
 */
export const EDITOR_INPUT_DEBOUNCE_MS = 400;
